import { Col, Row, TableColumnsType } from 'antd';
import { Table, TableGroup } from 'components';
// 2023/10/24 Leading Win 作業員シフト表廃止対応 start
// import { Business, TypeDates } from 'constant';
import { Business } from 'constant';
// 2023/10/24 Leading Win 作業員シフト表廃止対応 end
import { routes } from 'navigations/routers';
import { FC, useEffect, useState } from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import * as Types from 'types';
// 2023/10/24 Leading Win 作業員シフト表廃止対応 start
// import { ShopSchedules } from 'types';
// import { handleDate } from 'utils';
// import moment from 'moment';
// 2023/10/24 Leading Win 作業員シフト表廃止対応 end
import { uniqueId } from 'lodash';
import { WorkerShiftTableStyle } from '../styles';

type Props = {
  // 2023/10/24 Leading Win 作業員シフト表廃止対応 start
  // dataUnpropertyListShop?: Types.UnpropertyListShop[];
  dataUnpropertyListShop?: Types.PropertyInfoType[];
  // 2023/10/24 Leading Win 作業員シフト表廃止対応 start
  loadingUnpropertyListShop: boolean;
  dataShopSchedules: Types.ShopSchedulesItemSelect[];
  loadingShopSchedules: boolean;
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
  error_message: string;
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end
};

// 2023/10/24 Leading Win 作業員シフト表廃止対応 start
// type TypeData = {
//   site_name: string;
//   building_id: number;
//   site_address: string;
//   site_director_name: string;
//   schedules: ShopSchedules[] | undefined;
//   building_code: string;
// };
type TypeData = {
  building_id: number;
  site_code: string;
  site_name: string;
  site_address: string;
  site_director_name: string;
  // 2025/02/07 LW No62 start
  //  start_date: string;
  //  end_date: string;
  // 2025/02/07 LW No62 end
  // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
  gyosya_code?: string;
  gyosya_siten_code?: string;
  // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
  // 2024/10/18 Leading Win 2.8次改善対応　DXWEBLOS00100_現場一覧(作業予定現場一覧) 同一現場の業者選択の仕様変更 start
  first_gyosya_code: string;
  // 2025/02/26 FJ 3月分反映分 NO32 start
  first_gyosya_siten_code: string;
  // 2025/02/26 FJ 3月分反映分 NO32 end
  first_gyosya_name: string;
  second_gyosya_code: string;
  second_gyosya_name: string;
  third_gyosya_code: string;
  third_gyosya_name: string;
  // 2024/10/18 Leading Win 2.8次改善対応　DXWEBLOS00100_現場一覧(作業予定現場一覧) 同一現場の業者選択の仕様変更 end
};
// 2023/10/24 Leading Win 作業員シフト表廃止対応 end

const WorkerShiftTable: FC<Props> = ({
  dataUnpropertyListShop,
  loadingUnpropertyListShop,
  dataShopSchedules,
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
  error_message,
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end
}) => {
  const [data, setData] = useState<TypeData[]>([]);

  useEffect(() => {
    if (!dataUnpropertyListShop?.length) {
      return;
    }
    const arr: TypeData[] = dataUnpropertyListShop.map((u) => {
      // 2023/10/24 Leading Win 作業員シフト表廃止対応 start
      // const findTime = dataShopSchedules.find((s) => s.building_id === u.building_date[0].building_id);

      // return {
      //   building_id: u?.building_id ?? '',
      //   building_code: u?.building_code ?? '',
      //   site_name: u?.site_name ?? '',
      //   site_address: u?.site_address ?? '',
      //   site_director_name: u?.site_director_name ?? '',
      //   schedules: findTime?.schedules ?? [],
      // };
      return {
        // 2023/11/21 Leading Win 作業員シフト表廃止対応  DXWEBLOS00100_現場一覧(作業予定現場一覧) start
        building_id: +u.building_data[0].building_id,
        // 2023/11/21 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) end
        site_code: u?.site_code ?? '',
        site_name: u?.site_name ?? '',
        site_address: u?.address ?? '',
        site_director_name: u?.director_name ?? '',
        // 2025/02/07 LW No62 start
        //start_date: u?.start_date.slice(0, 10) ?? '',
        //end_date: u?.end_date.slice(0, 10) ?? '',
        // 2025/02/07 LW No62 end
        // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
        gyosya_code: u?.gyosya_code ?? '',
        gyosya_siten_code: u?.gyosya_siten_code ?? '',
        // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
        // 2024/10/18 Leading Win 2.8次改善対応　DXWEBLOS00100_現場一覧(作業予定現場一覧) 同一現場の業者選択の仕様変更 start
        first_gyosya_code: u?.first_gyosya_code ?? '',
        // 2025/02/26 FJ 3月分反映分 NO32 start
        first_gyosya_siten_code: u?.first_gyosya_siten_code ?? '',
        // 2025/02/26 FJ 3月分反映分 NO32 end
        first_gyosya_name: u?.first_gyosya_name ?? '',
        second_gyosya_code: u?.second_gyosya_code ?? '',
        second_gyosya_name: u?.second_gyosya_name ?? '',
        third_gyosya_code: u?.third_gyosya_code ?? '',
        third_gyosya_name: u?.third_gyosya_name ?? '',
        // 2024/10/18 Leading Win 2.8次改善対応　DXWEBLOS00100_現場一覧(作業予定現場一覧) 同一現場の業者選択の仕様変更 end
      };
      // 2023/10/24 Leading Win 作業員シフト表廃止対応 end
    });
    setData(arr);
  }, [dataShopSchedules, dataUnpropertyListShop]);

  const history = useHistory();
  const columns: TableColumnsType<TypeData> = [
    {
      title: '工事コード',
      // 2023/10/24 Leading Win 作業員シフト表廃止対応 start
      // dataIndex: 'building_code',
      dataIndex: 'site_code',
      // 2023/10/24 Leading Win 作業員シフト表廃止対応 end
      render: (text, record) => (
        <span
          className="cursor-pointer"
          onClick={() =>
            history.push(
              generatePath(routes.BusinessDetail.path, {
                buildingId: record?.building_id,
                // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
                gyosya_code: record?.gyosya_code,
                gyosya_siten_code: record?.gyosya_siten_code,
                // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
                // 2025/02/26 FJ 3月分反映分 NO32 start
                first_gyosya_code: record?.first_gyosya_code,
                first_gyosya_siten_code: record?.first_gyosya_siten_code,
                // 2025/02/26 FJ 3月分反映分 NO32 end
                entity: Business?.WORK_STATUS,
              }),
              { state: record }
            )
          }
        >
          {text}
        </span>
      ),
    },
    {
      title: '現場名',
      dataIndex: 'site_name',
      className: 'boder-left',
      render: (text, record) => (
        <span
          className="cursor-pointer"
          onClick={() =>
            history.push(
              generatePath(routes.BusinessDetail.path, {
                buildingId: record?.building_id,
                // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
                gyosya_code: record?.gyosya_code,
                gyosya_siten_code: record?.gyosya_siten_code,
                // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
                // 2025/02/26 FJ 3月分反映分 NO32 start
                first_gyosya_code: record?.first_gyosya_code,
                first_gyosya_siten_code: record?.first_gyosya_siten_code,
                // 2025/02/26 FJ 3月分反映分 NO32 end
                entity: Business?.WORK_STATUS,
              }),
              { state: record }
            )
          }
        >
          {text}
        </span>
      ),
    },
    // 2024/10/18 Leading Win 同一現場の業者選択の仕様変更 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
    {
      title: '一次業者',
      dataIndex: 'first_gyosya_code',
      className: 'boder-left',
      render: (text, record) => (
        <span
          className="cursor-pointer"
          onClick={() =>
            history.push(
              generatePath(routes.BusinessDetail.path, {
                buildingId: record?.building_id,
                gyosya_code: record?.gyosya_code,
                gyosya_siten_code: record?.gyosya_siten_code,
                // 2025/02/26 FJ 3月分反映分 NO32 start
                first_gyosya_code: record?.first_gyosya_code,
                first_gyosya_siten_code: record?.first_gyosya_siten_code,
                // 2025/02/26 FJ 3月分反映分 NO32 end
                entity: Business?.WORK_STATUS,
              }),
              { state: record }
            )
          }
        >
          {`${text}/${record?.first_gyosya_name}`}
        </span>
      ),
    },
    {
      title: '二次業者',
      dataIndex: 'second_gyosya_code',
      className: 'boder-left',
      render: (text, record) => (
        <span
          className="cursor-pointer"
          onClick={() =>
            history.push(
              generatePath(routes.BusinessDetail.path, {
                buildingId: record?.building_id,
                gyosya_code: record?.gyosya_code,
                gyosya_siten_code: record?.gyosya_siten_code,
                // 2025/02/26 FJ 3月分反映分 NO32 start
                first_gyosya_code: record?.first_gyosya_code,
                first_gyosya_siten_code: record?.first_gyosya_siten_code,
                // 2025/02/26 FJ 3月分反映分 NO32 end
                entity: Business?.WORK_STATUS,
              }),
              { state: record }
            )
          }
        >
          {text !== '000000' ? `${text}/${record?.second_gyosya_name}` : '-'}
        </span>
      ),
    },
    {
      title: '三次業者',
      dataIndex: 'third_gyosya_code',
      className: 'boder-left',
      render: (text, record) => (
        <span
          className="cursor-pointer"
          onClick={() =>
            history.push(
              generatePath(routes.BusinessDetail.path, {
                buildingId: record?.building_id,
                gyosya_code: record?.gyosya_code,
                gyosya_siten_code: record?.gyosya_siten_code,
                // 2025/02/26 FJ 3月分反映分 NO32 start
                first_gyosya_code: record?.first_gyosya_code,
                first_gyosya_siten_code: record?.first_gyosya_siten_code,
                // 2025/02/26 FJ 3月分反映分 NO32 end
                entity: Business?.WORK_STATUS,
              }),
              { state: record }
            )
          }
        >
          {text !== '000000' ? `${text}/${record?.third_gyosya_name}` : '-'}
        </span>
      ),
    },
    // 2024/10/18 Leading Win 同一現場の業者選択の仕様変更 DXWEBLOS00100_現場一覧（作業予定現場一覧） end

    {
      title: '現場住所',
      dataIndex: 'site_address',
      className: 'boder-left',
      render: (text, record) => (
        <span
          className="cursor-pointer"
          onClick={() =>
            history.push(
              generatePath(routes.BusinessDetail.path, {
                buildingId: record?.building_id,
                // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
                gyosya_code: record?.gyosya_code,
                gyosya_siten_code: record?.gyosya_siten_code,
                // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
                // 2025/02/26 FJ 3月分反映分 NO32 start
                first_gyosya_code: record?.first_gyosya_code,
                first_gyosya_siten_code: record?.first_gyosya_siten_code,
                // 2025/02/26 FJ 3月分反映分 NO32 end
                entity: Business?.WORK_STATUS,
              }),
              { state: record }
            )
          }
        >
          {text}
        </span>
      ),
    },
    // 2025/02/07 LW No62 start
    //    {
    //      title: '作業開始日',
    //      // 2023/10/24 Leading Win 作業員シフト表廃止対応 start
    //      // dataIndex: 'schedules',
    //      dataIndex: 'start_date',
    //      // 2023/10/24 Leading Win 作業員シフト表廃止対応 end
    //      className: 'boder-left',
    //      render: (text, record) => {
    //        // 2023/10/24 Leading Win 作業員シフト表廃止対応 start
    //        // const minStartDate: string[] = text?.map((time: ShopSchedules) => time.start_date);
    //        // 2023/10/24 Leading Win 作業員シフト表廃止対応 end
    //        return (
    //          <span
    //            className="cursor-pointer"
    //            onClick={() =>
    //              history.push(
    //                generatePath(routes.BusinessDetail.path, {
    //                  buildingId: record?.building_id,
    //                  // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
    //                  gyosya_code: record?.gyosya_code,
    //                 gyosya_siten_code: record?.gyosya_siten_code,
    //                  // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
    //                  entity: Business?.WORK_STATUS,
    //                }),
    //                { state: record }
    //              )
    //            }
    //          >
    //            {/* 023/10/24 Leading Win 作業員シフト表廃止対応 start */}
    //            {/* {minStartDate
    //              ? moment(handleDate(minStartDate, TypeDates.MIN_START)).format('YYYY/MM/DD')
    //              : '-'} */}
    //            {text}
    //            {/* 2023/10/24 Leading Win 作業員シフト表廃止対応 end */}
    //          </span>
    //        );
    //      },
    //    },
    //    {
    //      title: '作業終了日',
    //      // 2023/10/24 Leading Win 作業員シフト表廃止対応 start
    //      // dataIndex: 'schedules',
    //      dataIndex: 'end_date',
    //      // 2023/10/24 Leading Win 作業員シフト表廃止対応 end
    //      className: 'boder-left',
    //      render: (text, record) => {
    //        // 2023/10/24 Leading Win 作業員シフト表廃止対応 start
    //        // const maxEndDate: string[] = text?.map((time: ShopSchedules) => time.end_date);
    //        // 2023/10/24 Leading Win 作業員シフト表廃止対応 end
    //        return (
    //          <span
    //            className="cursor-pointer"
    //            onClick={() =>
    //              history.push(
    //                generatePath(routes.BusinessDetail.path, {
    //                  buildingId: record?.building_id,
    //                  // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
    //                  gyosya_code: record?.gyosya_code,
    //                  gyosya_siten_code: record?.gyosya_siten_code,
    //                  // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
    //                  entity: Business?.WORK_STATUS,
    //                }),
    //                { state: record }
    //              )
    //            }
    //          >
    //            {/* 023/10/24 Leading Win 作業員シフト表廃止対応 start */}
    //            {/* {maxEndDate
    //              ? moment(handleDate(maxEndDate, TypeDates.MAX_END)).format('YYYY/MM/DD')
    //              : '-'} */}
    //            {text}
    //            {/* 023/10/24 Leading Win 作業員シフト表廃止対応 end */}
    //          </span>
    //        );
    //      },
    //    },
    // 2025/02/07 LW No62 end
    {
      title: '工事担当者名',
      dataIndex: 'site_director_name',
      className: 'boder-left',
      render: (text, record) => (
        <span
          className="cursor-pointer"
          onClick={() =>
            history.push(
              generatePath(routes.BusinessDetail.path, {
                buildingId: record?.building_id,
                // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
                gyosya_code: record?.gyosya_code,
                gyosya_siten_code: record?.gyosya_siten_code,
                // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
                // 2025/02/26 FJ 3月分反映分 NO32 start
                first_gyosya_code: record?.first_gyosya_code,
                first_gyosya_siten_code: record?.first_gyosya_siten_code,
                // 2025/02/26 FJ 3月分反映分 NO32 end
                entity: Business?.WORK_STATUS,
              }),
              { state: record }
            )
          }
        >
          {text}
        </span>
      ),
    },
  ];
  return (
    <WorkerShiftTableStyle>
      <Row>
        <Col span={24} className="table-content">
          {/* 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start */}
          {error_message && <p className="error-message">{error_message}</p>}
          {/* 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end */}
          <Table<TypeData>
            columns={columns}
            dataSource={data}
            loading={loadingUnpropertyListShop}
            components={{ body: { wrapper: TableGroup.Wrapper } }}
            rowKey={({ building_id }) => building_id ?? uniqueId()}
          />
        </Col>
      </Row>
    </WorkerShiftTableStyle>
  );
};

export default WorkerShiftTable;
